/**
 * Replaces an entity in a list of given entities with a new one if their IDs match.
 * @param {Object[]} entities List of entities
 * @param {Object} newEntity New entity
 * @param {String} id_param Name of the parameter containing unique entity ID
 */
export const replaceEntity = (entities, newEntity, id_param = "id") => (
  entities && entities.map(entity => (entity[id_param] === newEntity[id_param] ? newEntity : entity))
);

/**
 * Replaces or prepends an entity in a list of given entities with a new one if their IDs match.
 * @param {Object[]} entities List of entities
 * @param {Object} newEntity New entity
 * @param {String} id_param Name of the parameter containing unique entity ID
 */
export const prependOrReplaceEntity = (entities = [], newEntity, id_param = "id") => {
  const foundEntity = entities && entities.find(entity => entity[id_param] === newEntity[id_param]);
  if (foundEntity) {
    return replaceEntity(entities, newEntity, id_param);
  }
  return entities ? [newEntity, ...entities] : [newEntity];
};

/**
 * Replaces or appends an entity in a list of given entities with a new one if their IDs match.
 * @param {Object[]} entities List of entities
 * @param {Object} newEntity New entity
 * @param {String} id_param Name of the parameter containing unique entity ID
 */
export const appendOrReplaceEntity = (entities = [], newEntity, id_param = "id") => {
  const foundEntity = entities && entities.find(entity => entity[id_param] === newEntity[id_param]);
  if (foundEntity) {
    return replaceEntity(entities, newEntity, id_param);
  }
  return entities ? [...entities, newEntity] : [newEntity];
};

/**
 * Removes an entity in a list of given entities if their IDs match.
 * @param {Object[]} entities List of entities
 * @param {Object} entityToRemove Entity to remove
 * @param {String} id_param Name of the parameter containing unique entity ID
 */
export const removeEntity = (entities, entityToRemove, id_param = "id") => (
  entities && entities.filter(entity => (entity[id_param] !== entityToRemove[id_param]))
);
